<template>
  <div class="auto-img">
    <img
      :src="src"
      @load="onLoad"
      @error="onError"
      class="auto-img__img"
      :style="{
        objectFit: fit,
      }"
    />
    <div class="auto-img__loading" v-if="loading">
      <slot name="loading"></slot>
    </div>
    <div class="auto-img__error" v-if="error">
      <slot name="error"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      error: false,
    }
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    fit: {
      type: String,
      default: '',
    },
  },
  methods: {
    onLoad() {
      this.loading = false
      this.$emit('load')
    },
    onError() {
      this.loading = false
      this.error = true
      this.$emit('error')
    },
  },
  watch: {
    src: {
      handler(value) {
        if (value) {
          this.loading = true
          this.error = false
        } else {
          this.loading = false
          this.error = true
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
}
</script>
<style scoped lang="less">
.auto-img {
  position: relative;
  display: inline-block;
  .auto-img__img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .auto-img__error,
  .auto-img__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #969799;
    font-size: 14px;
    background-color: #f7f8fa;
    pointer-events: none;
  }
}
</style>
